import React from 'react';
import {
  useCommonContext,
  useOrderDetailsContext,
} from '../../../hooks/useContexts';

import { ExportButton, PrintButton } from './index';

export interface IOrderDetailsPageHeader {
  customerType: string;
}

export const OrderDetailsPageHeader = ({
  customerType,
}: IOrderDetailsPageHeader) => {
  const { isDesktop } = useCommonContext();
  const { orderDetailsData, setAlertState, setExportAlertState } =
    useOrderDetailsContext();
  if (!isDesktop) return null;
  if (customerType === 'b2b' && orderDetailsData) {
    return (
      <div className="no-print sui-flex sui-justify-end sui-items-center sui-h-full">
        <ExportButton
          orderDetailsData={orderDetailsData}
          setAlertState={setExportAlertState}
        />
        <PrintButton
          orderDetailsData={orderDetailsData}
          setAlertState={setAlertState}
        />
      </div>
    );
  }
  return null;
};
